/** @jsxImportSource @emotion/react */
import { DropDownProps } from "antd";
import { TableEllipsisWrapper } from "./table-components/TableEllipsisWrapper";
import { EllipsisDropdown } from "./EllipsisDropdown";

export const TableEllipsisDropdown = (props: DropDownProps) => {
  return (
    <TableEllipsisWrapper>
      <EllipsisDropdown {...props} />
    </TableEllipsisWrapper>
  );
};
